// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3mjhc","messages":"Chat_messages__IC33h","dateDivider":"Chat_dateDivider__1TTm_"};